<template>
  <div class="bg-white create-partner">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto">
        <p class="font-bold text-lg mb-6">Info Partner</p>
        <div class="mb-6 max-w-sm">
          <TextField type="text" label="ID" :disabled="true" v-model="id" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Nama" v-model="payloads.name" placeholder="Nama partner" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe</label>
          <CustomSelect :options="partnerTypes" v-model="selectedType" :default="selectedType" placeholder="Pilih tipe" optionLabel="name" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tanggal Kontrak Dimulai</label>
          <div class="relative">
            <div class="absolute z-1 left-3 top-1/2 transform -translate-y-1/2">
              <Calendar />
            </div>
            <date-pick v-model="contract_start" :isDateDisabled="isPastDate"></date-pick>
          </div>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tanggal Kontrak Berakhir</label>
          <div class="relative">
            <div class="absolute z-1 left-3 top-1/2 transform -translate-y-1/2">
              <Calendar />
            </div>
            <date-pick v-model="contract_end" :isDateDisabled="isPastDateMax"></date-pick>
          </div>
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="URL Notifikasi" v-model="payloads.notification_url" placeholder="URL Notifikasi" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Shared Key" v-model="payloads.shared_key" placeholder="Shared Key" />
        </div>
      </div>
      <div class="flex-1 mdmax:w-full mdmax:flex-auto">
        <div class="p-6 ">
          <p class="font-bold text-lg mb-6">No. Rekening</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Bank</label>
            <CustomSelect :options="bankCodes" v-model="selectedBank" :default="selectedBank" placeholder="Pilih nama bank" optionLabel="name" />
          </div>
          <div class="mb-12">
            <TextField type="text" label="No. Rekening" v-model="payloads.bank_account_no" placeholder="Masukan nomor rekening" />
          </div>
          <p class="font-bold text-lg mb-6">Logo</p>
          <div class="">
            <FileBrowser id="stnk" accept=".jpg, .png, .jpeg" label="Upload Logo" button="Browse" placeholder="Pilih file yang akan di upload" @change="handleFileSelect($event, 'avatar', 'logo')" />
            <div class="w-40 mt-4" v-if="payloads.logo">
              <img :src="payloads.logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    FileBrowser: () => import(/* webpackChunkName: "form" */ '@/components/Forms/FileBrowser'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button'),
    Calendar: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Calendar'),
    DatePick
  },
  data() {
    return {
      id: 0,
      selectedType: null,
      selectedBank: null,
      contract_start: null,
      contract_end: null,
      payloads: {
        name: null,
        partner_type: null,
        contract_start: null,
        contract_end: null,
        bank_id: null,
        bank_account_no: null,
        notification_url: null,
        shared_key: null,
        status: 'ACTIVE',
        logo: null
      }
    }
  },
  computed: {
    ...mapGetters('partner', ['partnerTypes']),
    ...mapGetters('master', ['bankCodes']),
    ...mapGetters('common', ['isMobile'])
  },
  created() {
    this.getPartnerTypes()
    this.getBankCodeList()
  },
  watch: {
    selectedType(val) {
      if (val) {
        this.payloads.partner_type = val.id
      }
    },
    selectedBank(val) {
      if (val) {
        this.payloads.bank_id = this.selectedBank.code
      }
    }
  },
  methods: {
    ...mapActions('partner', ['getPartnerTypes', 'createPartner']),
    ...mapActions('master', ['getBankCodes']),
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading', 'uploadImage']),
    submit() {
      this.payloads.contract_end = this.contract_end + 'T00:00:00+07:00'
      this.payloads.contract_start = this.contract_start + 'T00:00:00+07:00'
      this.showLoading()
      this.createPartner({
        payloads: this.payloads
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 2000, primaryText: 'Penambahan Partner Logistik Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
        })
      })
    },
    handleCallback() {
      this.$router.push('/partner')
    },
    getBankCodeList() {
      this.getBankCodes()
    },
    handleFileSelect(file, purpose, target) {
      this.showLoading()
      let imageData = new FormData()
      imageData.append('image', file)
      imageData.append('file_purpose', purpose)
      this.uploadImage({ payloads: imageData }).then(res => {
        this.hideLoading()
        this.payloads[target] = res.file_url
      })
    },
    isPastDate(date) {
      const currentDate = new Date()
      let maxDate = 0

      if (this.contract_end) {
        maxDate = new Date(this.contract_end)
        maxDate.setDate(maxDate.getDate() - 1)
        return date < currentDate || date > maxDate
      } else {
        return date < currentDate
      }
    },
    isPastDateMax(date) {
      let currentDate = 0
      if (this.contract_start) {
        currentDate = new Date(this.contract_start)
      } else {
        currentDate = new Date()
      }
      return date < currentDate
    }
  }
}
</script>
<style lang="scss" scoped>
.create-partner {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 14px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.25rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}
</style>
